import React from 'react';
import { useSelector } from 'react-redux';
import { Paper, ListItem, ListItemAvatar, Avatar, ListItemText } from '@mui/material';
import { reportIDsSelector } from '../../features/datacenter/reportSlice';
import ReportListItem from './ReportListItem';

const ReportListView = () => {
    const reportIDs = useSelector(reportIDsSelector);
    const trackItems = () => {
        return reportIDs.map(t => <ReportListItem key={t} reportID={t} />);
    }
    return (
        <Paper>

            {
                reportIDs.length === 0 ?
                    <ListItem key="noevent">
                        <ListItemAvatar>
                            <Avatar style={{ backgroundColor: 'Red' }}>
                                0
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="No saved reports found" />
                    </ListItem>
                    :
                    trackItems()
            }
        </Paper>
    );
}

export default ReportListView;